import { GraphQLClient } from 'graphql-request'
import { VENDURE_HUB_URL } from './constants'

export const serverApi = new GraphQLClient(VENDURE_HUB_URL, {
  credentials: 'include',
})
